<template lang="pug">
    div.auto-maintain
        template
            div(style="text-align: center; margin-top: 40px") 当前门店已启用保养智能检测服务，请使用 CRM-APP进行施工凭证提交
            div(style="text-align: center")
                img(
                    :src="APPqrcode"
                    style="margin: 5px auto; width: 120px; height: 120px;"
                )
                p 凯励程CRM APP下载
</template>

<script>
import { sonarUrlUtils } from '@/utils';

export default {
    name: 'AutoMaintenance',
    computed: {
        APPqrcode() {
            return sonarUrlUtils.gaiaApp;
        },
    },
    methods: {
    },
};
</script>
<style lang="scss" scoped>
.auto-maintain {
    padding: 20px 0 20px 20px;
    flex: 1;
}
</style>
